import { Container, Grid } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import InfoCard from '../elements/InfoCard';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import { SupervisedUserCircleOutlined } from '@mui/icons-material';

const HomeContent = ({
  registryUsers,
  recommendationUsers,
  productCount,
  categoryCount,
}) => {
  const cardData = [
    {
      title: 'Registry users',
      total: registryUsers,
      icon: <SupervisedUserCircleOutlined fontSize="large" />,
      link: '/users?usertype=registry',
    },
    {
      title: 'Recommendation users',
      total: recommendationUsers,
      icon: <GroupOutlinedIcon fontSize="large" />,
      link: '/users?usertype=recommendation',
    },
    {
      title: 'Categories',
      total: categoryCount,
      icon: <CategoryOutlinedIcon fontSize="large" />,
      link: '/categories',
    },
    {
      title: 'Products',
      total: productCount,
      icon: <StoreOutlinedIcon fontSize="large" />,
      link: '/products',
    },
  ];

  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        {cardData.map((card, index) => (
          <Grid item xs key={index}>
            <Link to={card.link} style={{ textDecoration: 'none' }}>
              <InfoCard
                title={card.title}
                total={card.total}
                icon={card.icon}
              />
            </Link>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default HomeContent;
